import AnimatedPage from "@/components/AnimatedPage";
import HeaderBox from "@/components/HeaderBox";
import HelmetMetaData from "@/components/HelmetMetaData";
import moment from "moment";
import { useState } from "react";
import { BsCalendarDate } from "react-icons/bs";
import { VscTag } from "react-icons/vsc";
import { TbRefresh } from "react-icons/tb";
import { Link } from "react-router-dom";
import OrderDetails from "./OrderDetails";
import Spinner from "@/components/Spinner";
import { emptyOrdersIcon } from "@/assets";

const OrderHistory = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [loading, setLoading] = useState(false);

  const orderHistory = {};

  const handleOrderClick = (orderDetails) => {
    setSelectedOrder(orderDetails);
    setIsModalOpen(true);
  };

  if (loading) return <Spinner />;

  return (
    <AnimatedPage>
      <HelmetMetaData
        title="Order History | Exam Tokens and Pins"
        description="View your purchase history of exam tokens and pins. Track your orders and manage your exam preparations efficiently."
      />

      <section className="p-3 sm:p-5">
        <div className="mb-6 flex flex-col-reverse items-start justify-between md:flex-row">
          <HeaderBox
            title="Order History"
            subtext="View your past purchases and transactions."
          />

          <div>
            <h2 className="text-sm font-medium">
              <Link to="/dashboard" className="hover:underline">
                Dashboard
              </Link>

              <span className="px-2 text-xl font-thin">/</span>

              <span className="text-gray-400">Order History</span>
            </h2>
          </div>
        </div>

        {orderHistory && orderHistory.length > 0 ? (
          <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-3">
            {orderHistory.map((order, index) => (
              <div
                key={index}
                className="dark:border-darkBorder dark:bg-darkInput cursor-pointer rounded-lg border p-4 shadow-sm transition-shadow duration-300 hover:shadow-md dark:text-white"
                onClick={() => handleOrderClick(order)}
              >
                <h1 className="font-manrope mb-3 text-xl font-bold dark:text-white">
                  {order.type}
                </h1>

                <div className="mb-1 flex items-center gap-1">
                  <TbRefresh className="text-lg text-gray-600 dark:text-gray-300" />
                  <p className="text-gray-600 dark:text-gray-300">
                    <span className="font-semibold">Transaction ID:</span>{" "}
                    {order.id}
                  </p>
                </div>

                <div className="flex items-center gap-1">
                  <BsCalendarDate className="text-lg text-gray-600 dark:text-gray-300" />
                  <p className="text-gray-600 dark:text-gray-300">
                    <span className="font-semibold">Date:</span>{" "}
                    {moment(order.date).format("Do, ddd MMM YYYY [at] h:mma")}
                  </p>
                </div>

                <div className="dark:border-darkBorder mt-4 flex items-center justify-between border-t pt-4">
                  <div className="flex items-center gap-1">
                    <VscTag className="text-xl text-gray-600 dark:text-gray-300" />
                    <p className="text-gray-600 dark:text-gray-300">
                      <span className="font-medium">Quantity:</span>{" "}
                      {order.token?.split(",").length}
                    </p>
                  </div>

                  <p className="text-lg font-semibold text-green-600">
                    {/* ₦{formatter.format(order.total)} */}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-10 flex items-center justify-center lg:mt-20">
            <div className="flex flex-col items-center justify-center gap-3">
              <img src={emptyOrdersIcon} alt="" />
              <p className="font-medium">No Orders yet</p>
            </div>
          </div>
        )}

        {isModalOpen && (
          <OrderDetails
            token={selectedOrder}
            open={isModalOpen}
            setOpen={setIsModalOpen}
          />
        )}
      </section>
    </AnimatedPage>
  );
};

export default OrderHistory;
